import { render } from "./SubMenu.vue?vue&type=template&id=06097ef8&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=06097ef8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06097ef8"

export default script